export default "__VITE_ASSET__CwTcYQDS__"